import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }
  const personal =
    '({q47.0} = 0 or {q47.0} = 1 or {q47.0} = 2 or {q47.0} = 3 or {q47.0} = 4) or ({q47.1} = 0 or {q47.1} = 1 or {q47.1} = 2 or {q47.1} = 3 or {q47.1} = 4) or ({q47.2} = 0 or {q47.2} = 1 or {q47.2} = 2 or {q47.2} = 3 or {q47.2} = 4) or ({q47.3} = 0 or {q47.3} = 1 or {q47.3} = 2 or {q47.3} = 3 or {q47.3} = 4) or ({q47.4} = 0 or {q47.4} = 1 or {q47.4} = 2 or {q47.4} = 3 or {q47.4} = 4) or ({q47.5} = 0 or {q47.5} = 1 or {q47.5} = 2 or {q47.5} = 3 or {q47.5} = 4)'
  const J1adiffcult =
    '{q69.0} = 1 or {q69.0} = 2 or {q69.0} = 3 or {q69.1} = 1 or {q69.1} = 2 or {q69.1} = 3 or {q69.2} = 1 or {q69.2} = 2 or {q69.2} = 3 or {q69.3} = 1 or {q69.3} = 2 or {q69.3} = 3 or {q69.4} = 1 or {q69.4} = 2 or {q69.4} = 3 or {q69.5} = 1 or {q69.5} = 2 or {q69.5} = 3 or {q69.6} = 1 or {q69.6} = 2 or {q69.6} = 3 or {q69.7} = 1 or {q69.7} = 2 or {q69.7} = 3 or {q69.8} = 1 or {q69.8} = 2 or {q69.8} = 3'
  const J1bdiffcult =
    '{q105.0} = 1 or {q105.0} = 2 or {q105.0} = 3 or {q105.1} = 1 or {q105.1} = 2 or {q105.1} = 3 or {q105.2} = 1 or {q105.2} = 2 or {q105.2} = 3 or {q105.3} = 1 or {q105.3} = 2 or {q105.3} = 3 or {q105.4} = 1 or {q105.4} = 2 or {q105.4} = 3 or {q105.5} = 1 or {q105.5} = 2 or {q105.5} = 3 or {q105.6} = 1 or {q105.6} = 2 or {q105.6} = 3 or {q105.7} = 1 or {q105.7} = 2 or {q105.7} = 3'
  const J1cdiffcult =
    '{q138.0} = 1 or {q138.0} = 2 or {q138.0} = 3 or {q138.1} = 1 or {q138.1} = 2 or {q138.1} = 3 or {q138.2} = 1 or {q138.2} = 2 or {q138.2} = 3 or {q138.3} = 1 or {q138.3} = 2 or {q138.3} = 3 or {q138.4} = 1 or {q138.4} = 2 or {q138.4} = 3 or {q138.5} = 1 or {q138.5} = 2 or {q138.5} = 3 or {q138.6} = 1 or {q138.6} = 2'

  const visibleIfConditionsInit = {
    q6: '{q5} = 0',
    q7: '{q5} = 1 or {q5} = 2',
    q8: '{q5} = 1 or {q5} = 2 or {q5} = 3 or {q5} = 4 or {q5} = 5',

    q15: '{q14} = "other"',

    q17: '{q16} = "other"',
    q18: '{q16} = "other"',
    q19: '{q16} = "other"',
    q20: '{q16} = "other"',
    q21: '{q16} = "other"',

    q23: '({q16} = "other") and ({q22} = 0 or {q22} = 1)',

    // 特殊矩陣
    q33: '{q32.0} = 1 or {q32.1} = 1 or {q32.2} = 1 or {q32.3} = 1 or {q32.4} = 1 or {q32.5} = 1 or {q32.6} = 1',
    'q33.row0': '{q32.0} = 1',
    'q33.row1': '{q32.1} = 1',
    'q33.row2': '{q32.2} = 1',
    'q33.row3': '{q32.3} = 1',
    'q33.row4': '{q32.4} = 1',
    'q33.row5': '{q32.5} = 1',
    'q33.row6': '{q32.6} = 1',
    q34: '{q33.0} = 1 or {q33.1} = 1 or {q33.2} = 1 or {q33.3} = 1 or {q33.4} = 1 or {q33.5} = 1 or {q33.6} = 1',
    'q34.row0': '{q33.0} = 1',
    'q34.row1': '{q33.1} = 1',
    'q34.row2': '{q33.2} = 1',
    'q34.row3': '{q33.3} = 1',
    'q34.row4': '{q33.4} = 1',
    'q34.row5': '{q33.5} = 1',
    'q34.row6': '{q33.6} = 1',
    q35: '{q33.0} = 0',
    q36: '{q33.1} = 0',
    q37: '{q33.2} = 0',
    q38: '{q33.3} = 0',
    q39: '{q33.4} = 0',
    q40: '{q33.5} = 0',
    q41: '{q33.6} = 0',

    q43: '{q42.0} = 0',
    q44: '{q42.1} = 0',
    q45: '{q42.2} = 0',
    q46: '{q42.3} = 0',

    // ++++++這邊可能會加一題++++++
    q48: personal,
    q49: '{q48} = 0 or {q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4',
    q50: '({q48} = 0 or {q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4) and ({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4)',
    q51: '({q48} = 0 or {q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4) and ({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4)',
    q52: '({q48} = 0 or {q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4) and ({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4)',
    q53: '({q48} = 0 or {q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4) and ({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4)',
    q54: '({q48} = 0 or {q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4) and ({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4)',
    q55: '({q48} = 0 or {q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4) and ({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4)',
    q56: '({q48} = 0 or {q48} = 1 or {q48} = 2 or {q48} = 3 or {q48} = 4) and ({q49} = 0 or {q49} = 1 or {q49} = 2 or {q49} = 3 or {q49} = 4)',

    q58: '{q57} anyof [0, 1, 2, "other"]',
    q59: '{q57} anyof [0, 1, 2, "other"]',
    q60: '{q57} anyof [0, 1, 2, "other"]',
    q61: '{q57} anyof [0, 1, 2, "other"]',
    q62: '{q57} anyof [0, 1, 2, "other"]',

    // ++++++這邊可能會加一題++++++
    q63: '({q57} anyof [0, 1, 2, "other"]) and ({q61.0} = 0 or {q61.0} = 1)',
    q64: '({q57} anyof [0, 1, 2, "other"]) and ({q61.1} = 0 or {q61.1} = 1)',
    q65: '({q57} anyof [0, 1, 2, "other"]) and ({q61.2} = 0 or {q61.2} = 1)',
    q66: '({q57} anyof [0, 1, 2, "other"]) and ({q61.3} = 0 or {q61.3} = 1)',
    q67: '({q57} anyof [0, 1, 2, "other"]) and ({q61.4} = 0 or {q61.4} = 1)',
    q68: '({q57} anyof [0, 1, 2, "other"]) and ({q61.5} = 0 or {q61.5} = 1)',

    // J1a
    q70: J1adiffcult,
    'q70.row0': '{q69.0} = 1 or {q69.0} = 2 or {q69.0} = 3',
    'q70.row1': '{q69.1} = 1 or {q69.1} = 2 or {q69.1} = 3',
    'q70.row2': '{q69.2} = 1 or {q69.2} = 2 or {q69.2} = 3',
    'q70.row3': '{q69.3} = 1 or {q69.3} = 2 or {q69.3} = 3',
    'q70.row4': '{q69.4} = 1 or {q69.4} = 2 or {q69.4} = 3',
    'q70.row5': '{q69.5} = 1 or {q69.5} = 2 or {q69.5} = 3',
    'q70.row6': '{q69.6} = 1 or {q69.6} = 2 or {q69.6} = 3',
    'q70.row7': '{q69.7} = 1 or {q69.7} = 2 or {q69.7} = 3',
    'q70.row8': '{q69.8} = 1 or {q69.8} = 2 or {q69.8} = 3',
    q71: J1adiffcult,
    'q71.row0': '{q69.0} = 1 or {q69.0} = 2 or {q69.0} = 3',
    'q71.row1': '{q69.1} = 1 or {q69.1} = 2 or {q69.1} = 3',
    'q71.row2': '{q69.2} = 1 or {q69.2} = 2 or {q69.2} = 3',
    'q71.row3': '{q69.3} = 1 or {q69.3} = 2 or {q69.3} = 3',
    'q71.row4': '{q69.4} = 1 or {q69.4} = 2 or {q69.4} = 3',
    'q71.row5': '{q69.5} = 1 or {q69.5} = 2 or {q69.5} = 3',
    'q71.row6': '{q69.6} = 1 or {q69.6} = 2 or {q69.6} = 3',
    'q71.row7': '{q69.7} = 1 or {q69.7} = 2 or {q69.7} = 3',
    'q71.row8': '{q69.8} = 1 or {q69.8} = 2 or {q69.8} = 3',
    q72: J1adiffcult,
    'q72.row0': '{q69.0} = 1 or {q69.0} = 2 or {q69.0} = 3',
    'q72.row1': '{q69.1} = 1 or {q69.1} = 2 or {q69.1} = 3',
    'q72.row2': '{q69.2} = 1 or {q69.2} = 2 or {q69.2} = 3',
    'q72.row3': '{q69.3} = 1 or {q69.3} = 2 or {q69.3} = 3',
    'q72.row4': '{q69.4} = 1 or {q69.4} = 2 or {q69.4} = 3',
    'q72.row5': '{q69.5} = 1 or {q69.5} = 2 or {q69.5} = 3',
    'q72.row6': '{q69.6} = 1 or {q69.6} = 2 or {q69.6} = 3',
    'q72.row7': '{q69.7} = 1 or {q69.7} = 2 or {q69.7} = 3',
    'q72.row8': '{q69.8} = 1 or {q69.8} = 2 or {q69.8} = 3',
    q73: '{q72.0} = 0',
    q74: '{q72.1} = 0',
    q75: '{q72.2} = 0',
    q76: '{q72.3} = 0',
    q77: '{q72.4} = 0',
    q78: '{q72.5} = 0',
    q79: '{q72.6} = 0',
    q80: '{q72.7} = 0',
    q81: '{q72.8} = 0',
    // J1-4a
    q82: '{q72.0} = 1 or {q72.1} = 1 or {q72.2} = 1 or {q72.3} = 1 or {q72.4} = 1 or {q72.5} = 1 or {q72.6} = 1 or {q72.7} = 1 or {q72.8} = 1',
    'q82.row0': '{q72.0} = 1',
    'q82.row1': '{q72.1} = 1',
    'q82.row2': '{q72.2} = 1',
    'q82.row3': '{q72.3} = 1',
    'q82.row4': '{q72.4} = 1',
    'q82.row5': '{q72.5} = 1',
    'q82.row6': '{q72.6} = 1',
    'q82.row7': '{q72.7} = 1',
    'q82.row8': '{q72.8} = 1',

    q83: J1adiffcult,
    'q83.row0': '{q69.0} = 1 or {q69.0} = 2 or {q69.0} = 3',
    'q83.row1': '{q69.1} = 1 or {q69.1} = 2 or {q69.1} = 3',
    'q83.row2': '{q69.2} = 1 or {q69.2} = 2 or {q69.2} = 3',
    'q83.row3': '{q69.3} = 1 or {q69.3} = 2 or {q69.3} = 3',
    'q83.row4': '{q69.4} = 1 or {q69.4} = 2 or {q69.4} = 3',
    'q83.row5': '{q69.5} = 1 or {q69.5} = 2 or {q69.5} = 3',
    'q83.row6': '{q69.6} = 1 or {q69.6} = 2 or {q69.6} = 3',
    'q83.row7': '{q69.7} = 1 or {q69.7} = 2 or {q69.7} = 3',
    'q83.row8': '{q69.8} = 1 or {q69.8} = 2 or {q69.8} = 3',
    q84: J1adiffcult,
    'q84.row0': '{q69.0} = 1 or {q69.0} = 2 or {q69.0} = 3',
    'q84.row1': '{q69.1} = 1 or {q69.1} = 2 or {q69.1} = 3',
    'q84.row2': '{q69.2} = 1 or {q69.2} = 2 or {q69.2} = 3',
    'q84.row3': '{q69.3} = 1 or {q69.3} = 2 or {q69.3} = 3',
    'q84.row4': '{q69.4} = 1 or {q69.4} = 2 or {q69.4} = 3',
    'q84.row5': '{q69.5} = 1 or {q69.5} = 2 or {q69.5} = 3',
    'q84.row6': '{q69.6} = 1 or {q69.6} = 2 or {q69.6} = 3',
    'q84.row7': '{q69.7} = 1 or {q69.7} = 2 or {q69.7} = 3',
    'q84.row8': '{q69.8} = 1 or {q69.8} = 2 or {q69.8} = 3',
    // J1-7a
    q85: J1adiffcult,
    'q85.row0': '{q69.0} = 1 or {q69.0} = 2 or {q69.0} = 3',
    'q85.row1': '{q69.1} = 1 or {q69.1} = 2 or {q69.1} = 3',
    'q85.row2': '{q69.2} = 1 or {q69.2} = 2 or {q69.2} = 3',
    'q85.row3': '{q69.3} = 1 or {q69.3} = 2 or {q69.3} = 3',
    'q85.row4': '{q69.4} = 1 or {q69.4} = 2 or {q69.4} = 3',
    'q85.row5': '{q69.5} = 1 or {q69.5} = 2 or {q69.5} = 3',
    'q85.row6': '{q69.6} = 1 or {q69.6} = 2 or {q69.6} = 3',
    'q85.row7': '{q69.7} = 1 or {q69.7} = 2 or {q69.7} = 3',
    'q85.row8': '{q69.8} = 1 or {q69.8} = 2 or {q69.8} = 3',
    q86: '{q85.0} = 0',
    q87: '{q85.1} = 0',
    q88: '{q85.2} = 0',
    q89: '{q85.3} = 0',
    q90: '{q85.4} = 0',
    q91: '{q85.5} = 0',
    q92: '{q85.6} = 0',
    q93: '{q85.7} = 0',
    q94: '{q85.8} = 0',

    q95: '{q85.0} = 1',
    q96: '{q85.1} = 1',
    q97: '{q85.2} = 1',
    q98: '{q85.3} = 1',
    q99: '{q85.4} = 1',
    q100: '{q85.5} = 1',
    q101: '{q85.6} = 1',
    q102: '{q85.7} = 1',
    q103: '{q85.8} = 1',
    // J1-8a
    q104: '{q85.0} = 1 or {q85.1} = 1 or {q85.2} = 1 or {q85.3} = 1 or {q85.4} = 1 or {q85.5} = 1 or {q85.6} = 1 or {q85.7} = 1 or {q85.8} = 1',
    'q104.row0': '{q85.0} = 1',
    'q104.row1': '{q85.1} = 1',
    'q104.row2': '{q85.2} = 1',
    'q104.row3': '{q85.3} = 1',
    'q104.row4': '{q85.4} = 1',
    'q104.row5': '{q85.5} = 1',
    'q104.row6': '{q85.6} = 1',
    'q104.row7': '{q85.7} = 1',
    'q104.row8': '{q85.8} = 1',

    // J1b
    q106: J1bdiffcult,
    'q106.row0': '{q105.0} = 1 or {q105.0} = 2 or {q105.0} = 3',
    'q106.row1': '{q105.1} = 1 or {q105.1} = 2 or {q105.1} = 3',
    'q106.row2': '{q105.2} = 1 or {q105.2} = 2 or {q105.2} = 3',
    'q106.row3': '{q105.3} = 1 or {q105.3} = 2 or {q105.3} = 3',
    'q106.row4': '{q105.4} = 1 or {q105.4} = 2 or {q105.4} = 3',
    'q106.row5': '{q105.5} = 1 or {q105.5} = 2 or {q105.5} = 3',
    'q106.row6': '{q105.6} = 1 or {q105.6} = 2 or {q105.6} = 3',
    'q106.row7': '{q105.7} = 1 or {q105.7} = 2 or {q105.7} = 3',
    q107: J1bdiffcult,
    'q107.row0': '{q105.0} = 1 or {q105.0} = 2 or {q105.0} = 3',
    'q107.row1': '{q105.1} = 1 or {q105.1} = 2 or {q105.1} = 3',
    'q107.row2': '{q105.2} = 1 or {q105.2} = 2 or {q105.2} = 3',
    'q107.row3': '{q105.3} = 1 or {q105.3} = 2 or {q105.3} = 3',
    'q107.row4': '{q105.4} = 1 or {q105.4} = 2 or {q105.4} = 3',
    'q107.row5': '{q105.5} = 1 or {q105.5} = 2 or {q105.5} = 3',
    'q107.row6': '{q105.6} = 1 or {q105.6} = 2 or {q105.6} = 3',
    'q107.row7': '{q105.7} = 1 or {q105.7} = 2 or {q105.7} = 3',
    q108: J1bdiffcult,
    'q108.row0': '{q105.0} = 1 or {q105.0} = 2 or {q105.0} = 3',
    'q108.row1': '{q105.1} = 1 or {q105.1} = 2 or {q105.1} = 3',
    'q108.row2': '{q105.2} = 1 or {q105.2} = 2 or {q105.2} = 3',
    'q108.row3': '{q105.3} = 1 or {q105.3} = 2 or {q105.3} = 3',
    'q108.row4': '{q105.4} = 1 or {q105.4} = 2 or {q105.4} = 3',
    'q108.row5': '{q105.5} = 1 or {q105.5} = 2 or {q105.5} = 3',
    'q108.row6': '{q105.6} = 1 or {q105.6} = 2 or {q105.6} = 3',
    'q108.row7': '{q105.7} = 1 or {q105.7} = 2 or {q105.7} = 3',
    q109: '{q108.0} = 0',
    q110: '{q108.1} = 0',
    q111: '{q108.2} = 0',
    q112: '{q108.3} = 0',
    q113: '{q108.4} = 0',
    q114: '{q108.5} = 0',
    q115: '{q108.6} = 0',
    q116: '{q108.7} = 0',
    // J1-4b
    q117: '{q108.0} = 1 or {q108.1} = 1 or {q108.2} = 1 or {q108.3} = 1 or {q108.4} = 1 or {q108.5} = 1 or {q108.6} = 1 or {q108.7} = 1',
    'q117.row0': '{q108.0} = 1',
    'q117.row1': '{q108.1} = 1',
    'q117.row2': '{q108.2} = 1',
    'q117.row3': '{q108.3} = 1',
    'q117.row4': '{q108.4} = 1',
    'q117.row5': '{q108.5} = 1',
    'q117.row6': '{q108.6} = 1',
    'q117.row7': '{q108.7} = 1',

    q118: J1bdiffcult,
    'q118.row0': '{q105.0} = 1 or {q105.0} = 2 or {q105.0} = 3',
    'q118.row1': '{q105.1} = 1 or {q105.1} = 2 or {q105.1} = 3',
    'q118.row2': '{q105.2} = 1 or {q105.2} = 2 or {q105.2} = 3',
    'q118.row3': '{q105.3} = 1 or {q105.3} = 2 or {q105.3} = 3',
    'q118.row4': '{q105.4} = 1 or {q105.4} = 2 or {q105.4} = 3',
    'q118.row5': '{q105.5} = 1 or {q105.5} = 2 or {q105.5} = 3',
    'q118.row6': '{q105.6} = 1 or {q105.6} = 2 or {q105.6} = 3',
    'q118.row7': '{q105.7} = 1 or {q105.7} = 2 or {q105.7} = 3',
    q119: J1bdiffcult,
    'q119.row0': '{q105.0} = 1 or {q105.0} = 2 or {q105.0} = 3',
    'q119.row1': '{q105.1} = 1 or {q105.1} = 2 or {q105.1} = 3',
    'q119.row2': '{q105.2} = 1 or {q105.2} = 2 or {q105.2} = 3',
    'q119.row3': '{q105.3} = 1 or {q105.3} = 2 or {q105.3} = 3',
    'q119.row4': '{q105.4} = 1 or {q105.4} = 2 or {q105.4} = 3',
    'q119.row5': '{q105.5} = 1 or {q105.5} = 2 or {q105.5} = 3',
    'q119.row6': '{q105.6} = 1 or {q105.6} = 2 or {q105.6} = 3',
    'q119.row7': '{q105.7} = 1 or {q105.7} = 2 or {q105.7} = 3',
    q120: J1bdiffcult,
    'q120.row0': '{q105.0} = 1 or {q105.0} = 2 or {q105.0} = 3',
    'q120.row1': '{q105.1} = 1 or {q105.1} = 2 or {q105.1} = 3',
    'q120.row2': '{q105.2} = 1 or {q105.2} = 2 or {q105.2} = 3',
    'q120.row3': '{q105.3} = 1 or {q105.3} = 2 or {q105.3} = 3',
    'q120.row4': '{q105.4} = 1 or {q105.4} = 2 or {q105.4} = 3',
    'q120.row5': '{q105.5} = 1 or {q105.5} = 2 or {q105.5} = 3',
    'q120.row6': '{q105.6} = 1 or {q105.6} = 2 or {q105.6} = 3',
    'q120.row7': '{q105.7} = 1 or {q105.7} = 2 or {q105.7} = 3',
    q121: '{q120.0} = 0',
    q122: '{q120.1} = 0',
    q123: '{q120.2} = 0',
    q124: '{q120.3} = 0',
    q125: '{q120.4} = 0',
    q126: '{q120.5} = 0',
    q127: '{q120.6} = 0',
    q128: '{q120.7} = 0',

    q129: '{q120.0} = 1',
    q130: '{q120.1} = 1',
    q131: '{q120.2} = 1',
    q132: '{q120.3} = 1',
    q133: '{q120.4} = 1',
    q134: '{q120.5} = 1',
    q135: '{q120.6} = 1',
    q136: '{q120.7} = 1',
    // J1-8b
    q137: '{q120.0} = 1 or {q120.1} = 1 or {q120.2} = 1 or {q120.3} = 1 or {q120.4} = 1 or {q120.5} = 1 or {q120.6} = 1 or {q120.7} = 1',
    'q137.row0': '{q120.0} = 1',
    'q137.row1': '{q120.1} = 1',
    'q137.row2': '{q120.2} = 1',
    'q137.row3': '{q120.3} = 1',
    'q137.row4': '{q120.4} = 1',
    'q137.row5': '{q120.5} = 1',
    'q137.row6': '{q120.6} = 1',
    'q137.row7': '{q120.7} = 1',

    // J1c
    // J1-5c
    q139: J1cdiffcult,
    'q139.row0': '{q138.0} = 1 or {q138.0} = 2 or {q138.0} = 3',
    'q139.row1': '{q138.1} = 1 or {q138.1} = 2 or {q138.1} = 3',
    'q139.row2': '{q138.2} = 1 or {q138.2} = 2 or {q138.2} = 3',
    'q139.row3': '{q138.3} = 1 or {q138.3} = 2 or {q138.3} = 3',
    'q139.row4': '{q138.4} = 1 or {q138.4} = 2 or {q138.4} = 3',
    'q139.row5': '{q138.5} = 1 or {q138.5} = 2 or {q138.5} = 3',
    'q139.row6': '{q138.6} = 1 or {q138.6} = 2 or {q138.6} = 3',
    q140: J1cdiffcult,
    'q140.row0': '{q138.0} = 1 or {q138.0} = 2 or {q138.0} = 3',
    'q140.row1': '{q138.1} = 1 or {q138.1} = 2 or {q138.1} = 3',
    'q140.row2': '{q138.2} = 1 or {q138.2} = 2 or {q138.2} = 3',
    'q140.row3': '{q138.3} = 1 or {q138.3} = 2 or {q138.3} = 3',
    'q140.row4': '{q138.4} = 1 or {q138.4} = 2 or {q138.4} = 3',
    'q140.row5': '{q138.5} = 1 or {q138.5} = 2 or {q138.5} = 3',
    'q140.row6': '{q138.6} = 1 or {q138.6} = 2 or {q138.6} = 3',
    // J1-7c
    q141: J1cdiffcult,
    'q141.row0': '{q138.0} = 1 or {q138.0} = 2 or {q138.0} = 3',
    'q141.row1': '{q138.1} = 1 or {q138.1} = 2 or {q138.1} = 3',
    'q141.row2': '{q138.2} = 1 or {q138.2} = 2 or {q138.2} = 3',
    'q141.row3': '{q138.3} = 1 or {q138.3} = 2 or {q138.3} = 3',
    'q141.row4': '{q138.4} = 1 or {q138.4} = 2 or {q138.4} = 3',
    'q141.row5': '{q138.5} = 1 or {q138.5} = 2 or {q138.5} = 3',
    'q141.row6': '{q138.6} = 1 or {q138.6} = 2 or {q138.6} = 3',
    q142: '{q141.0} = 0',
    q143: '{q141.1} = 0',
    q144: '{q141.2} = 0',
    q145: '{q141.3} = 0',
    q146: '{q141.4} = 0',
    q147: '{q141.5} = 0',
    q148: '{q141.6} = 0',

    q149: '{q141.0} = 1',
    q150: '{q141.1} = 1',
    q151: '{q141.2} = 1',
    q152: '{q141.3} = 1',
    q153: '{q141.4} = 1',
    q154: '{q141.5} = 1',
    q155: '{q141.6} = 1',
    q156: '{q141.0} = 1 or {q141.1} = 1 or {q141.2} = 1 or {q141.3} = 1 or {q141.4} = 1 or {q141.5} = 1 or {q141.6} = 1',
    'q156.row0': '{q141.0} = 1',
    'q156.row1': '{q141.1} = 1',
    'q156.row2': '{q141.2} = 1',
    'q156.row3': '{q141.3} = 1',
    'q156.row4': '{q141.4} = 1',
    'q156.row5': '{q141.5} = 1',
    'q156.row6': '{q141.6} = 1',

    q157: '{q156.0} = 0 or {q156.0} = 1 or {q156.0} = 2 or {q156.0} = 3 or {q156.1} = 0 or {q156.1} = 1 or {q156.1} = 2 or {q156.1} = 3 or {q156.2} = 0 or {q156.2} = 1 or {q156.2} = 2 or {q156.2} = 3 or {q156.3} = 0 or {q156.3} = 1 or {q156.3} = 2 or {q156.3} = 3 or {q156.4} = 0 or {q156.4} = 1 or {q156.4} = 2 or {q156.4} = 3 or {q156.5} = 0 or {q156.5} = 1 or {q156.5} = 2 or {q156.5} = 3 or {q156.6} = 0 or {q156.6} = 1 or {q156.6} = 2 or {q156.6} = 3',

    q159: '{q158} = 1',
    q169: '{q168} = 1 or {q168} = 2',
    q170: '{q168} = 1 or {q168} = 2',
    q171: '{q168} = 1 or {q168} = 2',
    q172: '{q168} = 1 or {q168} = 2',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [117.5]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: `({q0} = 1))`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    if (survey.getValue('q0') === 1) {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
      )
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
